import { render, staticRenderFns } from "./GeneralInfo.htm?vue&type=template&id=59600c68&scoped=true&"
import script from "./GeneralInfo.ts?vue&type=script&lang=js&"
export * from "./GeneralInfo.ts?vue&type=script&lang=js&"
import style0 from "./GeneralInfo.scss?vue&type=style&index=0&id=59600c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59600c68",
  null
  
)

export default component.exports